// Core
import { useEffect } from 'react'

// App
import { useWebsiteConfigStore } from '@src/stores'
import { useGetWebsiteConfig } from '@src/api/endpoints/website-config'
import { GetWebsiteConfigQueryType } from '@src/api/types/website-config'

// Use fetch user information
export const useFetchWebsiteConfig = () => {
  // Stores
  // Client
  const setWebsiteConfig = useWebsiteConfigStore((state) => state.setWebsiteConfig)

  // Server
  const getWebsiteConfigQuery = useGetWebsiteConfig<GetWebsiteConfigQueryType>()

  // Effects
  // Set store data after fetching website config
  useEffect(() => {
    if (getWebsiteConfigQuery.data) {
      const { name, logo, banner, banners, guide_video, exam_rules, theme } = getWebsiteConfigQuery.data.responseData
      setWebsiteConfig({
        name,
        logo: logo
          ? {
              id: logo._id,
              path: logo.file_path
            }
          : null,
        banner: banner ? { id: banner._id, path: banner.file_path } : null,
        banners: (banners ?? []).map((item) => ({
          id: item._id,
          path: item.file_path,
          mimeType: item.mime_type
        })),
        guideVideo: guide_video
          ? {
              id: guide_video._id,
              path: guide_video.file_path,
              mimeType: guide_video.mime_type
            }
          : null,
        questionConfig: exam_rules?.question_config ?? [],
        theme
      })
    }
  }, [getWebsiteConfigQuery.data, setWebsiteConfig])

  return {
    isFetching: getWebsiteConfigQuery.isFetching,
    isError: getWebsiteConfigQuery.isError
  }
}
